import AOS from "aos";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../../assets/css/Seminar.css";
import CountUp from "react-countup";

// ─── Data ──────────────────────────────────────────────────────────────────
const seminarData = {
  1: [
    {
      time: "09:00 – 10:30 AM",
      speaker: "Arun Kumar",
      role: "Automation Engineer",
      title: "Introduction to Industrial Automation",
      desc: "Learn the fundamentals of industrial automation including PLC basics, sensors, and industrial control systems.",
      tag: "Industrial Automation",
      // img: require("../../assets/img/seminar/avatar-1.jpg"),
    },
    {
      time: "11:00 – 12:30 PM",
      speaker: "Divya S",
      role: "Embedded Developer",
      title: "Embedded Systems Fundamentals",
      desc: "Overview of embedded systems architecture, microcontrollers, and real-world applications.",
      tag: "Embedded Systems",
      // img: require("../../assets/img/seminar/avatar-2.jpg"),
    },
    {
      time: "02:00 – 03:30 PM",
      speaker: "Rahul Verma",
      role: "IoT Specialist",
      title: "Introduction to IIOT Technology",
      desc: "Explore Industrial Internet of Things concepts and how connected devices transform industries.",
      tag: "IIOT Technology",
      // img: require("../../assets/img/seminar/avatar-3.jpg"),
    },
    {
      time: "04:00 – 05:30 PM",
      speaker: "Priya Sharma",
      role: "Digital Marketing Trainer",
      title: "Digital Marketing Basics",
      desc: "Understand SEO, social media marketing, and online branding strategies for businesses.",
      tag: "Digital Marketing",
      // img: require("../../assets/img/seminar/avatar-4.jpg"),
    },
  ],

  2: [
    {
      time: "09:00 – 10:30 AM",
      speaker: "Vikram R",
      role: "Automation Specialist",
      title: "PLC Programming Basics",
      desc: "Hands-on introduction to PLC programming and ladder logic used in industrial automation.",
      tag: "Industrial Automation",
      // img:require("../../assets/img/seminar/avatar-5.jpg"),
    },
    {
      time: "11:00 – 12:30 PM",
      speaker: "Sneha K",
      role: "Embedded Trainer",
      title: "Microcontroller Programming",
      desc: "Learn programming techniques for microcontrollers used in embedded systems.",
      tag: "Embedded Systems",
      // img: require("../../assets/img/seminar/avatar-6.jpg"),
    },
    {
      time: "02:00 – 03:30 PM",
      speaker: "Arjun Patel",
      role: "IoT Engineer",
      title: "Sensors & Connectivity in IIOT",
      desc: "Understanding industrial sensors, connectivity protocols, and real-time monitoring.",
      tag: "IIOT Technology",
      // img: require("../../assets/img/seminar/avatar-7.jpg"),
    },
    {
      time: "04:00 – 05:30 PM",
      speaker: "Kavya N",
      role: "SEO Specialist",
      title: "SEO & Website Optimization",
      desc: "Learn search engine optimization strategies to improve website visibility and ranking.",
      tag: "Digital Marketing",
      // img: require("../../assets/img/seminar/avatar-8.jpg"),
    },
  ],

  3: [
    {
      time: "09:00 – 10:30 AM",
      speaker: "Sanjay M",
      role: "Automation Trainer",
      title: "SCADA Systems Overview",
      desc: "Introduction to SCADA systems used for monitoring and controlling industrial processes.",
      tag: "Industrial Automation",
      // img: require("../../assets/img/seminar/avatar-9.jpg"),
    },
    {
      time: "11:00 – 12:30 PM",
      speaker: "Meera S",
      role: "Embedded Engineer",
      title: "Embedded C Programming",
      desc: "Learn Embedded C concepts used to program microcontrollers and hardware devices.",
      tag: "Embedded Systems",
      // img: require("../../assets/img/seminar/avatar-10.jpg"),
    },
    {
      time: "02:00 – 03:30 PM",
      speaker: "Karthik P",
      role: "IoT Architect",
      title: "IIOT Cloud Integration",
      desc: "Understand how industrial devices connect to cloud platforms for data analytics.",
      tag: "IIOT Technology",
      // img: require("../../assets/img/seminar/avatar-11.jpg"),
    },
    {
      time: "04:00 – 05:30 PM",
      speaker: "Nisha R",
      role: "Marketing Consultant",
      title: "Social Media Marketing",
      desc: "Strategies to grow businesses through Facebook, Instagram, and LinkedIn marketing.",
      tag: "Digital Marketing",
      // img: require("../../assets/img/seminar/avatar-12.jpg"),
    },
  ],

  4: [
    {
      time: "09:00 – 10:30 AM",
      speaker: "Rajesh K",
      role: "Automation Engineer",
      title: "Industrial Networking Basics",
      desc: "Learn communication protocols used in automation like Modbus, Profibus, and Ethernet/IP.",
      tag: "Industrial Automation",
      // img: require("../../assets/img/seminar/avatar-13.jpg"),
    },
    {
      time: "11:00 – 12:30 PM",
      speaker: "Deepa T",
      role: "Embedded Specialist",
      title: "Real-Time Embedded Systems",
      desc: "Understanding real-time systems and their applications in embedded technologies.",
      tag: "Embedded Systems",
      // img: require("../../assets/img/seminar/avatar-14.jpg"),
    },
    {
      time: "02:00 – 03:30 PM",
      speaker: "Varun B",
      role: "IoT Developer",
      title: "Smart Factory with IIOT",
      desc: "How IIOT enables smart factories and improves industrial productivity.",
      tag: "IIOT Technology",
      // img: require("../../assets/img/seminar/avatar-15.jpg"),
    },
    {
      time: "04:00 – 05:30 PM",
      speaker: "Ananya S",
      role: "Digital Strategist",
      title: "Google Ads & Paid Marketing",
      desc: "Learn paid advertising strategies using Google Ads for business growth.",
      tag: "Digital Marketing",
      // img: require("../../assets/img/seminar/avatar-16.jpg"),
    },
  ],

  5: [
    {
      time: "09:00 – 10:30 AM",
      speaker: "Praveen R",
      role: "Full Stack Developer",
      title: "Introduction to Web Development",
      desc: "Overview of HTML, CSS, JavaScript and how modern websites are built.",
      tag: "IT & Software Development",
      // img: require("../../assets/img/seminar/avatar-17.jpg"),
    },
    {
      time: "11:00 – 12:30 PM",
      speaker: "Swathi K",
      role: "Software Trainer",
      title: "Frontend Development Basics",
      desc: "Learn UI development with HTML, CSS, Bootstrap and responsive design techniques.",
      tag: "IT & Software Development",
      // img: require("../../assets/img/seminar/avatar-18.jpg"),
    },
    {
      time: "02:00 – 03:30 PM",
      speaker: "Ajay M",
      role: "Backend Developer",
      title: "Backend Development Overview",
      desc: "Introduction to server-side programming, APIs, and database integration.",
      tag: "IT & Software Development",
      // img: require("../../assets/img/seminar/avatar-19.jpg"),
    },
    {
      time: "04:00 – 05:30 PM",
      speaker: "Keerthi V",
      role: "Tech Mentor",
      title: "Career Opportunities in IT",
      desc: "Guidance on building a successful career in software development and emerging technologies.",
      tag: "IT & Software Development",
      // img: require("../../assets/img/seminar/avatar-20.jpg"),
    },
  ],
};

const automationTopics = [
  {
    icon: "fa-cogs",
    title: "Introduction to Industrial Automation",
    desc: "Basics and major benefits in modern manufacturing",
  },
  {
    icon: "fa-chart-line",
    title: "Future of Automation",
    desc: "Latest trends and Industry 4.0 innovations",
  },
  {
    icon: "fa-microchip",
    title: "PLC & SCADA Systems",
    desc: "Real-world applications and troubleshooting",
  },
  {
    icon: "fa-network-wired",
    title: "Smart Manufacturing & IoT",
    desc: "Integration of IoT in industrial processes",
  },
];

const digitalTopics = [
  {
    icon: "fa-bullhorn",
    title: "Power of Digital Marketing",
    desc: "How digital strategies reshape businesses",
  },
  {
    icon: "fa-brands fa-instagram",
    title: "Social Media Mastery",
    desc: "Campaigns on Instagram, Facebook & LinkedIn",
  },
  {
    icon: "fa-search",
    title: "SEO & Search Engine Strategies",
    desc: "Improve visibility and organic rankings",
  },
  {
    icon: "fa-chart-bar",
    title: "Analytics & ROI Optimization",
    desc: "Data-driven decision making",
  },
];

const allTopics = [...automationTopics, ...digitalTopics];

const speakers = [
  {
    name: "Ben Sheridan",
    role: "Founder & CEO",
    bio: "15+ years in web development & digital strategy",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Sophie Lana",
    role: "Senior Developer",
    bio: "WordPress expert & open-source contributor",
    img: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "James Moult",
    role: "Cloud Architect",
    bio: "AWS certified, 200+ successful deployments",
    img: "https://randomuser.me/api/portraits/men/55.jpg",
  },
  {
    name: "Oscar Holman",
    role: "Theme Specialist",
    bio: "Custom theme author with 10K+ installations",
    img: "https://randomuser.me/api/portraits/men/67.jpg",
  },
];

const faqData = [
  [
    "Who should attend these seminars?",
    "Professionals, engineering students, business owners, and anyone looking to upgrade their skills in automation or digital marketing.",
  ],
  [
    "Do I need prior experience?",
    "No. We have sessions for beginners as well as advanced learners. Each track is clearly labelled for your convenience.",
  ],
  [
    "Is certification provided?",
    "Yes. Every participant receives an official certificate from Skimitar Hindusthan Pvt Ltd, valid for professional portfolios.",
  ],
  [
    "Are the sessions offline or online?",
    "Currently all sessions are conducted offline at our Salem campus for an immersive, hands-on experience.",
  ],
  [
    "How do I register?",
    "Fill out the registration form on this page or contact us directly. Early registration is recommended as seats are limited.",
  ],
  [
    "Is there a fee to attend?",
    "Some sessions are complimentary for students. Corporate packages and group discounts are available—contact us for details.",
  ],
];

const stats = [
  { value: 500, label: "Past Attendees" },
  { value: 20, label: "Industry Topics" },
  { value: 98, label: "Satisfaction Rate" },
  { value: 100, label: "Certified" },
];

// ─── Component ─────────────────────────────────────────────────────────────
export default function Seminar() {
  const [activeDay, setActiveDay] = useState(1);

  useEffect(() => {
    if (typeof AOS !== "undefined")
      AOS.init({ duration: 900, once: true, offset: 60 });
  }, []);

  const currentSeminars = seminarData[activeDay] || [];

  // Heading
  function SectionLabel({ text }) {
    return (
      <p
        className="fw-semibold text-uppercase mb-1"
        style={{ fontSize: 20, color: "#cc0000", letterSpacing: 1 }}
      >
        {text}
      </p>
    );
  }

  return (
    <div className="body">
      {/* <Helmet>
        <title>
          Seminars for Professional Excellence | Skimitar Hindusthan Pvt Ltd
        </title>
        <link rel="canonical" href="https://skimitaracademy.com/seminars" />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
        />
      </Helmet> */}

      {/* <style>{styles}</style> */}

      {/* ── HERO ── */}
      {/* <section className="sem-hero">
        <div className="sem-hero__bg" />
        <div className="sem-hero__grid-overlay" />
        <div className="sem-hero__content">
          <div className="sem-hero__eyebrow">Skimitar Hindusthan Pvt Ltd</div>
          <h1 className="sem-hero__title">
            Seminars for
            <br />
            <em>Professional</em>
            <br />
            Excellence
          </h1>
          <p className="sem-hero__subtitle">
            High-impact seminars in Industrial Automation and Digital Marketing
            — crafted for professionals, students, and leaders ready to
            accelerate their careers.
          </p>
          <button className="sem-hero__cta">
            Reserve Your Seat <i className="fa-solid fa-arrow-right"></i>
          </button>
          <div className="sem-hero__stats">
            {[
              ["5", "Day Seminar"],
              ["8+", "Speakers"],
              ["200+", "Seats"],
              ["1", "Certificate"],
            ].map(([n, l]) => (
              <div className="sem-hero__stat" key={l}>
                <div className="sem-hero__stat-num">{n}</div>
                <div className="sem-hero__stat-label">{l}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="sem-hero__scroll">
          <span>Scroll</span>
          <div className="sem-hero__scroll-line" />
        </div>
      </section> */}

      <div
        className="backgroundCommenImage position-relative d-flex align-items-center mb-5"
        style={{
          backgroundImage: `url(${require("../../assets/img/seminar/Banner.jpg")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "60vh",
        }}
      >
        {/* Overlay */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ background: "rgba(0, 0, 0, 0.8)", zIndex: 1 }}
        ></div>

        {/* Content */}
        <div
          className="container position-relative text-center text-white py-4 py-md-5"
          style={{ zIndex: 2 }}
        >
          {/* Badge */}
          <span
            className="fw-semibold d-inline-block mb-3 px-3 py-1 rounded-pill"
            style={{
              background: "#cc0000",
              fontSize: "clamp(10px,3vw,12px)",
              letterSpacing: "0.5px",
            }}
          >
            Skimitar Hindusthan Seminars
          </span>

          {/* Heading */}
          <h1
            className="fw-semibold mb-3"
            style={{
              fontSize: "clamp(18px,5vw,28px)",
              lineHeight: 1.4,
            }}
          >
            Seminars for Professional
            <br />
            <span style={{ color: "#cc0000" }}>Excellence</span>
          </h1>

          {/* Text */}
          <p
            className="mx-auto mb-4 px-2 px-md-0"
            style={{
              fontSize: "clamp(13px,3.5vw,15px)",
              maxWidth: "650px",
              lineHeight: 1.7,
              color: "#ebe6e6",
            }}
          >
            High-impact seminars in Industrial Automation and Digital Marketing
            — crafted for professionals, students, and leaders ready to
            accelerate their careers.
          </p>

          {/* Pills */}
          {/* <div className="d-flex flex-wrap justify-content-center gap-2 gap-md-3">
              {datas.map((s, i) => (
                <div
                  key={s.label}
                  className="text-white px-3 py-2 rounded-pill"
                  style={{
                    border: "1px solid rgba(255,255,255,0.3)",
                    fontSize: "clamp(8px,3vw,10px)",
                  }}
                >
                  <span className="fw-semibold">{s.data}</span>
                </div>
              ))}
            </div> */}
        </div>
      </div>

      {/* ── INTRODUCTION ── */}
      <div className="container margin_top container_width">
        <div className="row align-items-center justify-content-center g-5">
          {/* Left Content */}
          <div className="col-lg-6">
            <SectionLabel text="About the Seminars" />

            <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
              Where Industry Meets Innovation
            </h2>

            <p className="mb-3" style={{ fontSize: 15 }}>
              <span className="fw-semibold">Skimitar Hindusthan Pvt Ltd</span>{" "}
              brings you a curated series of seminars led by industry
              practitioners — combining real-world expertise with actionable
              takeaways you can implement immediately.
            </p>

            <p className="mb-3" style={{ fontSize: 15 }}>
              Whether you're a professional looking to future-proof your skills
              or a student ready to step into industry, these seminars offer
              hands-on learning, expert mentorship, and a powerful network of
              peers.
            </p>

            <ul className="list-unstyled mt-4">
              {[
                "Hands-on workshops with live demonstrations",
                "Globally recognised certification on completion",
                "Access to exclusive learning materials & resources",
              ].map((item, i) => (
                <li key={i} className="d-flex align-items-start mb-3">
                  <span className="text-red me-2">
                    <i className="fa-solid fa-check"></i>
                  </span>
                  <span className="small">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Image */}
          <div className="col-lg-6 text-center">
            <div className="position-relative d-inline-block">
              <img
                src={require("../../assets/img/seminar/seminar-1.jpg")}
                alt="Seminar"
                className="img-fluid rounded-4"
              />

              <div
                className="position-absolute top-0 start-0 bg-red p-3 rounded d-none d-lg-block"
                style={{
                  transform: "translate(-20%, -20%)",
                  width: "100px",
                  height: "80px",
                }}
              >
                <strong className="d-block">
                  {new Date().toLocaleString("en-US", { month: "long" })}
                </strong>
                <small>{new Date().getFullYear()}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── STATS BAND ── */}
      <section className="margin_top">
        <div className="container">
          <div className="row g-4 text-center">
            {stats.map((item, i) => (
              <div
                key={i}
                className={`col-6 col-md-6 col-lg-3 ${i >= 2 ? "mt-md-3" : "mt-lg-0"}`}
              >
                <div className="card border-0 shadow p-4 h-100">
                  <h2 className="fw-bold text-danger mb-2">
                    <CountUp start={0} end={item.value} duration={10} />+
                  </h2>

                  <p className="text-uppercase small text-dark mb-0">
                    {item.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SCHEDULE ── */}
      <section className="margin_top py-5 bg_color">
        <div className="container container_width">
          <SectionLabel text="Seminar Schedules" />
          <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
            Programme at a Glance
          </h2>
          <p className="mb-3" style={{ fontSize: 15 }}>
            Select a day to explore the sessions planned for that date.
          </p>

          {/* Tabs */}
          <div className="d-flex justify-content-center mb-4">
            <div
              className="btn-group rounded-2 flex-nowrap overflow-auto"
              role="group"
            >
              {[1, 2, 3, 4, 5].map((day) => (
                <button
                  key={day}
                  type="button"
                  className={`btn mt-3 ${
                    activeDay === day ? "bg-red" : "btn-outline-dark"
                  }`}
                  onClick={() => setActiveDay(day)}
                >
                  Day {String(day).padStart(2, "0")}
                </button>
              ))}
            </div>
          </div>

          {/* Schedule Cards */}
          {currentSeminars.length > 0 ? (
            currentSeminars.map((sem, i) => (
              <div
                key={i}
                className={`d-flex align-items-center gap-4 py-4 px-3 px-md-4 border-bottom 
      ${i % 2 === 1 ? "bg-light text-dark" : "bg-white"}`}
                data-aos="fade-up"
              >
                {/* Time */}
                <div
                  className={`${i % 2 === 1 ? "text-dark" : "text-dark"} small`}
                  style={{ minWidth: "130px" }}
                >
                  {sem.time}
                </div>

                {/* Speaker Image */}
                <div className="flex-shrink-0">
                  <img
                    src={require("../../assets/img/seminar/Avatar.jpg")}
                    alt={sem.speaker}
                    className="rounded-circle border"
                    style={{
                      width: "72px",
                      height: "72px",
                      objectFit: "cover",
                    }}
                  />
                </div>

                {/* Speaker Name & Role */}
                <div style={{ minWidth: "130px" }}>
                  <div className="fw-semibold small">{sem.speaker}</div>
                  <div className="small mt-1 text-danger">{sem.role}</div>
                </div>

                {/* Title & Description */}
                <div className="flex-grow-1">
                  <h6 className="fw-bold mb-2">{sem.title}</h6>
                  <p
                    className={`${i % 2 === 1 ? "text-dark" : "text-dark"} small mb-0 lh-base`}
                  >
                    {sem.desc}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center p-5">
              <h4 className="fw-bold mb-2">Sessions Announced Soon</h4>
              <p className="text-muted">
                Day 05 lineup is being finalised. Check back shortly.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* ── WHAT YOU'LL LEARN ── */}
      <section className="margin_top">
        <div className="container container_width">
          {/* Heading */}
          <SectionLabel text="Curriculum" />
          <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
            What You Will Learn
          </h2>

          {/* Topics */}
          <div className="row g-4">
            {allTopics.map((item, i) => (
              <div
                key={i}
                className="col-12 col-sm-6 col-lg-3"
                data-aos="fade-up"
                data-aos-delay={i * 60}
              >
                <div className="sem-topic-card shadow h-100 position-relative">
                  {/* Number */}
                  <span className="sem-topic-num">
                    {String(i + 1).padStart(2, "0")}
                  </span>

                  {/* Icon */}
                  <div className="sem-topic-icon">
                    <i className={`fa-solid ${item.icon}`} />
                  </div>

                  {/* Title */}
                  <h5 className="fw-semibold mb-2">{item.title}</h5>

                  {/* Description */}
                  <p className="mb-0">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY ATTEND ── */}
      <section className="margin_top py-5 bg_color">
        <div className="container container_width">
          <div className="row align-items-center justify-content-center g-5">
            {/* Left Image */}
            <div className="col-12 col-lg-6 position-relative">
              <img
                src={require("../../assets/img/seminar/seminar-2.jpg")}
                alt="Why Attend"
                className="img-fluid rounded-4"
              />

              {/* Floating Card */}
              <div className="mt-3 text-center">
                <span>
                  {new Date().toLocaleString("en-US", { month: "long" })}{" "}
                  Seminar
                </span>
                <strong className="text-red">
                  {" "}
                  {new Date().getFullYear()}
                </strong>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-12 col-lg-6">
              <SectionLabel text="Why Attend" />
              <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
                Built for Real-World Impact
              </h2>

              <ul className="list-unstyled d-flex flex-column gap-3">
                {[
                  [
                    "fa-user-graduate",
                    "Expert-Led Sessions",
                    "Learn directly from seasoned practitioners with decades of industry experience.",
                  ],
                  [
                    "fa-certificate",
                    "Official Certification",
                    "Receive a recognised certificate upon completing the seminar series.",
                  ],
                  [
                    "fa-handshake",
                    "Networking Opportunities",
                    "Connect with 200+ professionals, potential employers, and collaborators.",
                  ],
                  [
                    "fa-laptop-code",
                    "Hands-On Practice",
                    "Every theory session is paired with a practical, applied workshop.",
                  ],
                  [
                    "fa-briefcase",
                    "Career Advancement",
                    "Leverage new skills and certification to accelerate your career trajectory.",
                  ],
                ].map(([icon, title, desc], i) => (
                  <li key={i} className="d-flex gap-3 align-items-start">
                    <div className="icon-box">
                      <i className={`fa-solid ${icon}`} />
                    </div>

                    <div>
                      <strong className="d-block small">{title}</strong>
                      <p className="text-muted small mb-0">{desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="margin_top mb-5">
        <div className="container container_width">
          {/* Heading */}
          <SectionLabel text="faq" />
          <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
            Frequently Asked Questions
          </h2>

          {/* Accordion */}
          <div className="accordion" id="faqAccordion">
            {faqData.map(([q, a], i) => (
              <div className="accordion-item" key={i}>
                <h2 className="accordion-header fw-bold">
                  <button
                    className={`accordion-button ${i !== 0 ? "collapsed" : ""}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#faq${i}`}
                  >
                    {q}
                  </button>
                </h2>

                <div
                  id={`faq${i}`}
                  className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body small">{a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
